export default function userSubMenuData(
    showPayShipFeature: boolean,
    manageJobAdsUrl = 'https://recruiters.gumtree.com/job-listing/'
) {
    const subMenuData = [
        {
            url: '/manage/ads',
            label: 'Manage my Ads',
            icon: 'folder',
            eventAction: 'HeaderDropdownSelect',
            eventLabel: 'ManageAds',
        },
        ...(showPayShipFeature
            ? [
                  {
                      url: '/manage/orders',
                      label: 'My Orders',
                      icon: 'todo',
                      eventAction: 'HeaderDropdownSelect',
                      eventLabel: 'MyOrders',
                  },
              ]
            : []),
        {
            url: '/manage/messages',
            label: 'Messages',
            icon: 'envelope',
            eventAction: 'HeaderDropdownSelect',
            eventLabel: 'MyMessages',
        },
        {
            url: '/my-account/favourites',
            label: 'Favourites',
            icon: 'full-heart',
            eventAction: 'HeaderDropdownSelect',
            eventLabel: 'Favourites',
        },
        {
            url: '/my-account/saved-searches',
            label: 'My Alerts',
            icon: 'bell',
            eventAction: 'HeaderDropdownSelect',
            eventLabel: 'SavedSearches',
        },
        {
            url: '/manage-account',
            label: 'My Details',
            icon: 'person',
            eventAction: 'HeaderDropdownSelect',
            eventLabel: 'MyAccount',
        },
        {
            url: manageJobAdsUrl,
            label: 'Manage my Job Ads',
            icon: 'tie',
            eventAction: 'HeaderDropdownSelect',
            eventLabel: 'ManageMyJobAds',
        },
        {
            url: 'https://help.gumtree.com',
            label: 'Help & Contact',
            icon: 'circ-question-mark',
            eventAction: 'HeaderDropdownSelect',
            eventLabel: 'Help',
        },
    ];

    return subMenuData;
}
